import React from 'react';
import './styles.scss';
import { EditIcon } from 'cokitchen-icons';
import { MealPricingType } from 'models/pricing.model';

const VendorBulkActions = ({
  item,
  editFunc,
  showBulkActions,
  setShowBulkActions,
  setSelectedItems
}: {
  item: any;
  editFunc: () => void;
  showBulkActions: boolean;
  setShowBulkActions: (arg1: boolean) => void;
  setSelectedItems: (arg1: MealPricingType[]) => void;
}) => {
  return (
    <div className='absolute bottom-2 sm:bottom-8 left-4 sm:left-[10%] md:left-[18%] lg:left-[40%]'>
      {showBulkActions && (
        <div className='bulk-actions bg-white flex flex-wrap justify-start sm:justify-between items-center gap-6 sm:gap-4 mx-auto rounded-full py-5 px-[22px]'>
          <p className='text-[#6F7376] text-sm'>{item.length} items selected</p>

          <button
            onClick={() => {
              editFunc();
            }}
            className='cursor-pointer flex justify-between items-center gap-1 text-xs bg-[#F2F2F2] rounded-[8px] text-[#585F68] px-[12px] py-[6px] h-[29px]'>
            <EditIcon />
            Edit
          </button>

          <button
            onClick={() => {
              setShowBulkActions(false);
              setSelectedItems([]);
            }}
            className='cursor-pointer text-xs bg-[#E60A2B] rounded-[8px] text-white px-[12px] py-[6px] h-[29px]'>
            Done
          </button>
        </div>
      )}
    </div>
  );
};

export default VendorBulkActions;
